import type { ReactNode } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

export interface ActivityCompletionData {
  day: string;
  completed: number;
  scheduled: number;
}

interface ActivityCompletionChartProps {
  data: ActivityCompletionData[];
}

export function ActivityCompletionChart({
  data,
}: ActivityCompletionChartProps): ReactNode {
  if (data.length === 0) {
    return (
      <div className="card">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Activity Completion (This Week)</h3>
        <div className="h-64 flex items-center justify-center text-gray-500">
          No activity data available
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Activity Completion (This Week)</h3>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="day"
              tick={{ fontSize: 12 }}
            />
            <YAxis
              tick={{ fontSize: 12 }}
              allowDecimals={false}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'white',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
              }}
            />
            <Legend />
            <Bar
              dataKey="completed"
              name="Completed"
              fill="#16a34a"
              radius={[4, 4, 0, 0]}
              barSize={20}
            />
            <Bar
              dataKey="scheduled"
              name="Scheduled"
              fill="#94a3b8"
              radius={[4, 4, 0, 0]}
              barSize={20}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
